import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// import 'bootstrap/dist/css/bootstrap.css';
import './assets/fontawesome-free-5.11.2-web/css/all.min.css';
import './assets/main.css';

// import 'jquery/src/jquery';
// import 'bootstrap/dist/js/bootstrap.bundle'

ReactDOM.render(<App />,document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
